import cn from 'classnames';
import type React from 'react';
import { useCallback, useState } from 'react';
import { useSupportPageRedirect } from '@pages/support/model.ts';
import { PageBackButton } from '@features/common/PageBackButton/index.tsx';
import { useSupportForm } from '@features/support';
import { usePlatformSettings } from '@shared/hooks/index.ts';
import { Card, ListBody, PageHead, PageTitle } from '@shared/ui';
import CustomInput from '@src/modules/Authentication/CustomInput';
import * as st from './styles.module.scss';

const getCorrectPhone = (phoneNumber?: string) => {
  return phoneNumber ? phoneNumber.replace(/[^+\d]/g, '') : '';
};

export const Support: React.FC = () => {
  const [page, setPage] = useState<'call' | 'write' | 'choice'>('choice');

  const { register, errors, submit, control } = useSupportForm();
  const { support_phone } = usePlatformSettings();

  const { doRedirectOnPrevPage } = useSupportPageRedirect();

  const onPageBackButtonClick = useCallback(() => {
    if (page !== 'choice') {
      setPage('choice');
    } else {
      doRedirectOnPrevPage('/');
    }
  }, [page, setPage, doRedirectOnPrevPage]);

  const onSandMessageButtonClick = () => {
    setPage('write');
  };

  return (
    <>
      <PageTitle title="Техническая поддержка" />
      <PageHead
        Left={<PageBackButton onClick={onPageBackButtonClick} />}
        Right={
          page === 'write' ? (
            <button className={st.active} type="submit" onClick={submit}>
              Отправить
            </button>
          ) : undefined
        }
      />
      <ListBody>
        {page === 'choice' && (
          <Card className={st.choiceWrapper}>
            <p>
              По любым техническим вопросам вы можете позвонить нам с 9:00 до 18:00 по МСК (GMT +3),
              либо отправить собщение
            </p>
            <section className={st.choiceButtons}>
              <a href={`tel:${getCorrectPhone(support_phone)}`} className={st.choiceButton}>
                {support_phone}
              </a>
              <button className={st.choiceButton} onClick={onSandMessageButtonClick}>
                Написать сообщение
              </button>
            </section>
          </Card>
        )}
        {/*{page === 'call' && (*/}
        {/*  <Card className={st.wrapper}>*/}
        {/*    <p className={st.wrapper__info}>*/}
        {/*      По любым техническим вопросам вы можете позвонить нам с 9:00 до 18:00 по МСК (GMT +3)*/}
        {/*    </p>*/}
        {/*    <div className={st.wrapper__phone}>*/}
        {/*      <div className={st.wrapper__phone__icon}>*/}
        {/*        <PhoneClientProfile />*/}
        {/*      </div>*/}
        {/*      <a className={st.wrapper__phone__tel} href="tel:+79034066499">*/}
        {/*        + 7 (903) 406 - 64 - 99*/}
        {/*      </a>*/}
        {/*    </div>*/}
        {/*  </Card>*/}
        {/*)}*/}
        {page === 'write' && (
          <div className={st.safety}>
            <form onSubmit={submit} className={st.container}>
              <fieldset>
                <h3>КОНТАКТНЫЙ ТЕЛЕФОН ДЛЯ СВЯЗИ</h3>
                <Card className={cn(st.card_input, errors.subject && st.error)}>
                  <CustomInput
                    tabindex={1}
                    type="phonenumber"
                    label=""
                    name={`subject`}
                    control={control}
                    error={errors?.subject}
                    disabled={false}
                  />
                </Card>
              </fieldset>

              <fieldset>
                <h3>ТЕКСТ СООБЩЕНИЯ</h3>
                <Card className={cn(st.card_textarea, errors.comment && st.error)}>
                  <textarea
                    className={cn(st.input, st.area)}
                    id="comment"
                    {...register('comment')}
                  />
                </Card>
              </fieldset>
            </form>
          </div>
        )}
      </ListBody>
    </>
  );
};
